// frontend/src/components/BadgeCertifie.js

export default function BadgeCertifie({ isValidated, compact = false }) {
  if (!isValidated) return null;

  if (compact) {
    return (
      <div
        title="Compte certifié EVO-LIVE"
        style={{
          width: "20px",
          height: "20px",
          borderRadius: "50%",
          background: "linear-gradient(135deg,#00b0ff,#0066ff)",
          color: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "13px",
          fontWeight: 900,
          border: "2px solid #071018",
          boxShadow: "0 0 7px rgba(0,176,255,.75)",
          boxSizing: "border-box"
        }}
      >
        ✔
      </div>
    );
  }

  return (
    <div
      style={{
        background: "linear-gradient(90deg,#00b0ff,#0066ff)",
        padding: "6px 14px",
        borderRadius: "999px",
        fontSize: "0.75rem",
        color: "white",
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        marginTop: "8px",
        boxShadow: "0 0 8px rgba(0,0,0,0.4)"
      }}
    >
      <span style={{ fontSize: "14px" }}>✔</span>
      Certifié EVO-LIVE
    </div>
  );
}
